import uuid from 'uuid/v4'
import axios from 'axios'
import store from '@plat/store'

export function sendHit (type, hitProperties = {}) {
  const route = getRoute()

  const hit = mergeHit(
    {
      event_id: getEventId(),
      type,
      user: getUser(),
      session: getSession(),
      page_url: window.location.href,
      page_referrer: window.document.referrer,
      route_name: route.name,
      route_parameters: route.parameters,
      language: getLanguage(),
      screen_size: getScreenSize(),
      viewport: getViewport()
    },
    hitProperties
  )

  axios.post('/x/api/platform/analytics', hit)
}

export function sendHitPage (pageUrl) {
  const hit = {
    page_url: pageUrl || window.location.href
  }

  sendHit('page', hit)
}

export function sendHitTrack (properties) {
  const hit = {
    properties
  }

  sendHit('track', hit)
}

export function sendHitBeat (pageUrl) {
  const hit = {
    page_url: pageUrl || window.location.href
  }

  sendHit('beat', hit)
}

export function startHeartBeat (pageUrl, every = 15000) {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      stopHeartBeatInterval()
    } else if (!intervalId) {
      startHeartBeatInterval(pageUrl, every)
    }
  })

  startHeartBeatInterval(pageUrl, every)
}

let intervalId = null

function startHeartBeatInterval (pageUrl, every) {
  intervalId = setInterval(() => {
    sendHitBeat(pageUrl)
  }, every)
}

function stopHeartBeatInterval () {
  clearInterval(intervalId)
  intervalId = null
}

function mergeHit (hitA, hitB) {
  let hit = {
    ...hitA,
    ...hitB
  }

  hit.properties = {
    ...hitA.properties,
    ...hitB.properties
  }

  return hit
}

function getEventId () {
  return store.state.routeParameters.event.id
}

function getUser () {
  if (!window.localStorage) {
    return null
  }

  let user = window.localStorage.getItem('analyticsUser')

  if (!user) {
    user = uuid()
    window.localStorage.setItem('analyticsUser', user)
  }

  return user
}

function getSession () {
  if (!window.sessionStorage) {
    return null
  }

  let session = window.sessionStorage.getItem('analyticsSession')
  const sessionDate = parseInt(window.sessionStorage.getItem('analyticsSessionDate'))
  const currentDate = new Date().getTime()
  const maxDifference = 600000 // 1000 * 60 * 10 => 10 min

  if (!session || currentDate > sessionDate + maxDifference) {
    session = uuid()
    window.sessionStorage.setItem('analyticsSession', session)
  }

  window.sessionStorage.setItem('analyticsSessionDate', currentDate.toString())

  return session
}

function getRoute () {
  return {
    name: store.state.routeName,
    parameters: store.state.routeParameters
  }
}

function getLanguage () {
  if (navigator.hasOwnProperty('languages')) {
    return navigator.languages[0]
  }

  return navigator.language || navigator.browserLanguage || navigator.userLanguage
}

function getScreenSize () {
  return window.screen.width + 'x' + window.screen.height
}

function getViewport () {
  return window.innerWidth + 'x' + window.innerHeight
}
